import { useNavigate } from 'react-router-dom';

/* Shared quick-action photos (existing portal assets) */
export const ROLE_IMG = {
  order: 'https://customer-assets.emergentagent.com/job_distribution-pro-1/artifacts/2a6nldba_SILK_SMOOTH_500ml_-_REVITALISE_EXTREME.png?v=7',
  reorder: 'https://customer-assets.emergentagent.com/job_distribution-pro-1/artifacts/i1l3ymok_IMG_4102.jpeg',
  products: 'https://customer-assets.emergentagent.com/job_distribution-pro-1/artifacts/hr39zv7y_IMG_4103.jpeg',
  academy: 'https://customer-assets.emergentagent.com/job_distribution-pro-1/artifacts/mq5pw1lv_IMG_2381.jpeg',
  quotes: 'https://customer-assets.emergentagent.com/job_distribution-pro-1/artifacts/he1v9fq5_59722371-fabd-4eac-9e15-a51950b8bade.jpeg',
  team: 'https://customer-assets.emergentagent.com/job_distribution-pro-1/artifacts/t07s1klz_715b1a6a-ba8d-4f07-b700-4df7265b546b.jpeg',
  salons: 'https://customer-assets-agu9un31.emergentagent.net/job_distribution-pro-1/artifacts/f6980aa53822f3a3_IMG_3874.png',
  invite: 'https://customer-assets.emergentagent.com/job_distribution-pro-1/artifacts/m8bwdwig_cb0dc23a-d63b-4416-8e21-32f021250fc0.jpeg',
  shop: 'https://customer-assets.emergentagent.com/job_distribution-pro-1/artifacts/mq5pw1lv_IMG_2381.jpeg',
  bookings: 'https://customer-assets-agu9un31.emergentagent.net/job_distribution-pro-1/artifacts/51dc38d4da612975_IMG_3875.png',
  miles: 'https://customer-assets-agu9un31.emergentagent.net/job_distribution-pro-1/artifacts/4113061df0be4297_IMG_3876.png',
};

/* RoleCards — the Academy role card copied exactly: photo with plum fade,
   small gold label and Bodoni title over the photo, one short line
   underneath, bronze link with an arrow. 4 across desktop, 2 on phone. */
export const RoleCards = ({ items, testId = 'role-cards' }) => {
  const navigate = useNavigate();
  return (
    <div className="rvk-roles" data-testid={testId}>
      {items.filter(Boolean).slice(0, 4).map((it) => (
        <button key={it.title} type="button" className="rvk-role"
          onClick={() => (it.onClick ? it.onClick() : navigate(it.path))}
          data-testid={`role-card-${it.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
          <span className="rimg">
            {it.img && <img src={it.img} alt="" loading="lazy" />}
            <span className="rcap">
              <span className="rey">{it.label}</span>
              <b>{it.title}</b>
            </span>
          </span>
          <span className="rtxt">
            <span>{it.line}</span>
            <em>{it.cta} &rarr;</em>
          </span>
        </button>
      ))}
    </div>
  );
};
